import { render, staticRenderFns } from "./IconHourGlass.vue?vue&type=template&id=406ec120&scoped=true&"
import script from "./IconHourGlass.vue?vue&type=script&lang=js&"
export * from "./IconHourGlass.vue?vue&type=script&lang=js&"
import style0 from "./IconHourGlass.vue?vue&type=style&index=0&id=406ec120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ec120",
  null
  
)

export default component.exports